<div class="m-r-16">
  <mat-slide-toggle
    #toggleSlide
    (change)="toggle($event)"
    class="m-l-16"
    matTooltip="enable/disable 2fa"
  />
</div>
